// src/pages/subscription/BundleEditPage.tsx
// Legacy route kept resolvable for old links/bookmarks. Bundles are edited
// inline on BundleDetailPage now (BundleFormDialog reused for edit) — there
// is no edit route/mode, per docs/ux/14-forms.md. This route just sends
// people to the detail page.

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const BundleEditPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(id ? `/subscriptions/bundles/${id}` : '/subscriptions/bundles', { replace: true });
  }, [navigate, id]);
  return null;
};

export default BundleEditPage;
